import axios from 'axios';
import config from '@/vue-caas/config/config.js';
import { compareSort } from '@/vue-dlb/common/common';
import api from '@/vue-dlb/utils/setup-api';
const baseURI = config.setupApiUrl;

const processStoreModule = {
  // namespaced: false,

  state: {
    processList: [],
    processHistoryList: [],
    processDtlList: [],
    process: {},
    foldList: [],
    detailDir: {},
    dbBrkList: [],
    processListPaging: [],
    processListFilter: [],
    processDtlHistoryList: [],
    processSelectBoxList: [],
    processHistory: {},
  },
  mutations: {
    SET_STORE_PROCESS_LIST(state, processList) {
      state.processList = processList;
      state.processListPaging = [...processList];
      state.processListSource = [...processList];
    },
    SET_STORE_PROCESS_SELECT_BOX_LIST(state, processSelectBoxList) {
      state.processSelectBoxList = processSelectBoxList;
    },
    SET_STORE_PROCESS_HISTORY_LIST(state, processList) {
      state.processHistoryList = processList;
    },
    SET_STORE_PROCESS_DETAIL_LIST(state, processDtlList) {
      state.processDtlList = processDtlList;
    },
    SET_STORE_PROCESS(state, id) {
      if (id !== undefined && id !== null && id !== '') {
        const procList = state.processList;
        for (let i = 0; i < procList.length; i += 1) {
          const procInfo = procList[i];
          if (procInfo.id === id) {
            state.process = JSON.parse(JSON.stringify(procInfo));
            break;
          }
        }
      } else {
        state.process = {};
      }
    },
    // 05/27/2021 203737 SPKA-113 issue 27 Develop UI program of the "Folders" function
    SET_STORE_FOLDER_LIST(state, foldList) {
      state.foldList = foldList;
    },
    foldList(state, datarows) {
      state.foldList = datarows;
    },
    SET_STORE_DIR(state, detailDir) {
      state.detailDir = detailDir;
    },
    SET_STORE_DBBRK_LIST(state, dbBrkList) {
      state.dbBrkList = dbBrkList;
    },
    /**
     * 2021.07.30 203737 SPKA-167 issue 110 Add fixed column in Workflow search result list
     * Workflow : Name, Partner, Sender, Receiver, Message
     */
    SET_STORE_PROCESS_LIST_PAGING(state, paging) {
      let datarows = [...state.processListSource];
      state.processList = datarows.slice(paging.startIndex, paging.endIndex);
      state.processListPaging = [...state.processList];
    },
    // 2021.11.17 213960 SPKA-248 issue 168 Modify page function of Workflow search screen
    SET_STORE_PROCESS_LIST_FILTER_PAGING(state, paging) {
      let datarows = state.processList;
      state.processList = datarows.slice(paging.startIndex, paging.endIndex);
      state.processListPaging = [...state.processList];
    },
    SET_STORE_PROCESS_LIST_FILTER(state, filter) {
      let datarows = [...state.processListSource];
      state.filter = filter;
      let filterBy = state.filter;
      let arrFilter = [];
      if (filterBy != null) {
        let filter = filterBy.filter;
        let strSearch = filterBy.strSearch;
        if (strSearch.trim() == '') {
          arrFilter = datarows;
        }
        arrFilter = datarows.filter((item) => {
          if (filter == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = strSearch.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = strSearch.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[filter] == 'string') {
              let propValue = item[filter].toLowerCase();
              let queryValue = strSearch.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[filter] == 'number') {
              let propValue = item[filter].toString().toLowerCase();
              let queryValue = strSearch.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
        });
      }
      state.processList = arrFilter;
      state.processListFilter = [...arrFilter];
    },
    SET_STORE_PROCESS_LIST_SORT(state, data) {
      let datarows = state.processList;
      let { col, sort } = data;
      // console.log('SET_STORE_PROCESS_LIST_SORT', sort, col)
      if (sort === 'reset') {
        state.processList = [...state.processListPaging];
        if (state.filter && state.filter.strSearch) {
          // console.log("SET_STORE_PROCESS_LIST_SORT_FILTER", state.filter)
          state.processList = [...state.processListFilter];
        }
        return;
      }
      datarows.sort((pre, next) => {
        let propPre = pre[col];
        let propNext = next[col];
        return compareSort(propPre, propNext, sort);
      });

      state.processList = datarows;
    },
    SET_STORE_PROCESS_DETAIL_HISTORY_LIST(state, processDtlHistoryList) {
      state.processDtlHistoryList = processDtlHistoryList;
    },
    SET_STORE_PROCESS_HISTORY(state, params) {
      if (params) {
        const procList = state.processHistoryList;
        for (let i = 0; i < procList.length; i++) {
          const procInfo = procList[i];
          if (procInfo.procId === params.procId && procInfo.verNo * 10 === params.versionNo * 10) {
            state.processHistory = JSON.parse(JSON.stringify(procInfo));
            break;
          }
        }
      } else {
        state.processHistory = {};
      }
    },
  },
  actions: {
    getProcessList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/process/list`, params);
        // console.log(response.data);
        commit('SET_STORE_PROCESS_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_PROCESS_LIST', []);
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    // 2021.4.2 203728 Get list workflow new
    getProcessListNew: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/process/list/workflow`, params);
        // console.log(response.data);
        commit('SET_STORE_PROCESS_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_PROCESS_LIST', []);
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    getProcessSelectBoxList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/process/list/workflow`, params);
        // console.log(response.data);
        commit('SET_STORE_PROCESS_SELECT_BOX_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_PROCESS_SELECT_BOX_LIST', []);
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    processHistory: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/proc/history`, params);
        commit('SET_STORE_PROCESS_HISTORY_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_PROCESS_HISTORY_LIST', []);
        throw err;
      }
    },
    processHistoryNew: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/process/history`, params);
        commit('SET_STORE_PROCESS_HISTORY_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_PROCESS_HISTORY_LIST', []);
        throw err;
      }
    },
    insertProcess: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/proc/insert`, params);
        // console.log(response.data);
        return response.data;
      } catch (err) {
        commit('SET_STORE_PROCESS_LIST', []);
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    insertProcessNew: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/process/insert`, params);
        // console.log(response.data);
        return response.data;
      } catch (err) {
        commit('SET_STORE_PROCESS_LIST', []);
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    updateProcess: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/proc/update`, params);
        // console.log(response.data);
        commit('SET_STORE_PROCESS_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_PROCESS_LIST', []);
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    updateProcessNew: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/process/update`, params);
        // console.log(response.data);
        commit('SET_STORE_PROCESS_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_PROCESS_LIST', []);
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    deleteProcess: async ({ commit }, params) => {
      try {
        const response = await api.postData('proc/delete', params);
        // const response = await axios.post(`${baseURI}/proc/delete`, params);
        // console.log(response.data);
        // commit('SET_STORE_PROCESS_LIST', response.data);
      } catch (err) {
        // commit('SET_STORE_PROCESS_LIST', []);
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    deleteProcessNew: async ({ commit }, params) => {
      try {
        const response = await api.postData('process/delete', params);
        // const response = await axios.post(`${baseURI}/proc/delete`, params);
        // console.log(response.data);
        // commit('SET_STORE_PROCESS_LIST', response.data);
      } catch (err) {
        // commit('SET_STORE_PROCESS_LIST', []);
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    // applyProcess: async ({commit}, params) => {
    //   try {
    //     // const response = await axios.post(`${baseURI}/proc/apply`, params);
    //     await axios.post(`${baseURI}/proc/apply`, params);
    //     // console.log(response.data);
    //     // alert(JSON.stringify(response.data));
    //   } catch (err) {
    //     commit('SET_STORE_PROCESS_LIST', []);
    //     // alert(err);
    //     // console.log(ex);
    //     throw err;
    //   }
    // },
    applyProcess: async ({ commit }, params) => {
      try {
        // const response = await axios.post(`${baseURI}/proc/apply`, params);
        await axios.post(`${baseURI}/process/apply`, params);
        // console.log(response.data);
        // alert(JSON.stringify(response.data));
      } catch (err) {
        commit('SET_STORE_PROCESS_LIST', []);
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    activateProcess: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/proc/activate`, params);
        // console.log(response.data);
        // alert(JSON.stringify(response.data));
      } catch (err) {
        commit('SET_STORE_PROCESS_LIST', []);
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    activateProcessNew: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/process/activate`, params);
        // console.log(response.data);
        // alert(JSON.stringify(response.data));
      } catch (err) {
        commit('SET_STORE_PROCESS_LIST', []);
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    setSrcOrDst: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/process/componentActivate`, params);
        // console.log(response.data);
      } catch (err) {
        throw err;
      }
    },
    getProcess: async ({ commit }, params) => {
      try {
        commit('SET_STORE_PROCESS', params);
      } catch (err) {
        commit('SET_STORE_PROCESS', null);
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    getProcessDtlList: async ({ commit }, params) => {
      try {
        const response = await api.postData('proc/dtl/list', params);
        // const response = await axios.post(`${baseURI}/proc/dtl/list`, params);
        // console.log(response.data)
        commit('SET_STORE_PROCESS_DETAIL_LIST', response.data);
      } catch (err) {
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    getProcessDtlListNew: async ({ commit }, params) => {
      try {
        const response = await api.postData('process/dtl/list', params);
        // const response = await axios.post(`${baseURI}/proc/dtl/list`, params);
        // console.log(response.data)
        commit('SET_STORE_PROCESS_DETAIL_LIST', response.data);
      } catch (err) {
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    /* 203665 issue 15 workflow
    Send JSON to kafka when update Communication , Mapper, panert
    */
    // updateProcessInfo: async ({commit}, params) => {
    //   try {
    //     const response = await axios.post(`${baseURI}/proc/updateProcess`, params);
    //     return response.data;
    //   } catch (err) {
    //     // alert(err);
    //     throw err;
    //   }
    // },
    updateProcessInfo: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/process/updateProcess`, params);
        return response.data;
      } catch (err) {
        // alert(err);
        throw err;
      }
    },
    // updateParnertProcessInfo: async ({commit}, params) => {
    //   try {
    //     await axios.post(`${baseURI}/proc/updateParnertProcess`, params);
    //   } catch (err) {
    //     // alert(err);
    //     throw err;
    //   }
    // },
    updateParnertProcessInfo: async ({ commit }, params) => {
      try {
        await axios.post(`${baseURI}/process/updateParnertProcess`, params);
      } catch (err) {
        // alert(err);
        throw err;
      }
    },
    // 05/27/2021 203737 SPKA-113 issue 27 Develop UI program of the "Folders" function
    queryFolderList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/folder/list`, params);
        commit('SET_STORE_FOLDER_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_FOLDER_LIST', []);
        throw err;
      }
    },
    addFolder: async ({ commit }, params) => {
      return await axios
        .post(`${baseURI}/folder/insert`, params)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    deleteWorkSpaceFolders: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/folder/delete`, params);
        commit('SET_STORE_FOLDER_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_FOLDER_LIST', []);
        throw err;
      }
    },
    getDetailDir: async ({ commit }, params) => {
      try {
        const response = await axios.get(`${baseURI}/folder/detail/${params.FOLD_ID}`);
        commit('SET_STORE_DIR', response.data);
      } catch (err) {
        commit('SET_STORE_DIR', {});
        throw err;
      }
    },
    updateFolder: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/folder/update`, params);
        commit('SET_STORE_FOLDER_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_FOLDER_LIST', []);
        throw err;
      }
    },
    getProcessDtlHistoryList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/proc/dtl/history/list`, params);
        commit('SET_STORE_PROCESS_DETAIL_HISTORY_LIST', response.data);
      } catch (err) {
        throw err;
      }
    },
    getProcessDtlHistoryListNew: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/process/dtl/history/list`, params);
        commit('SET_STORE_PROCESS_DETAIL_HISTORY_LIST', response.data);
      } catch (err) {
        throw err;
      }
    },
    getProcessHistory: async ({ commit }, params) => {
      try {
        commit('SET_STORE_PROCESS_HISTORY', params);
      } catch (err) {
        commit('SET_STORE_PROCESS_HISTORY', null);
        throw err;
      }
    },
    // 2021.11.8 203728 SPKA-243 set lock/unlock
    setLockUnlocProcess: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/proc/lockProcess`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    // 2021.11.8 203728 SPKA-243 check lock/unlock
    getLockProcess: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/proc/checkLockProcess`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    setLockUnlocProcessNew: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/process/lockProcess`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    // 2021.11.8 203728 SPKA-243 check lock/unlock
    getLockProcessNew: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/process/checkLockProcess`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    processList: (state) => state.processList,
    processSelectBoxList: (state) => state.processSelectBoxList,
    processHistoryList: (state) => state.processHistoryList,
    processDtlList: (state) => state.processDtlList,
    process: (state) => state.process,
    foldList: (state) => state.foldList,
    detailDir: (state) => state.detailDir,
    processDtlHistoryList: (state) => state.processDtlHistoryList,
    processHistory: (state) => state.processHistory,
  },
};

export default processStoreModule;
